"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useServiceTypeStore = void 0;
const pinia_1 = require("pinia");
const fetch_1 = __importDefault(require("../../../common/utils/fetch"));
const i18n_1 = __importDefault(require("../../../common/i18n"));
exports.useServiceTypeStore = (0, pinia_1.defineStore)("serviceTypeStore", {
    state: () => ({
        serviceTypes: [],
    }),
    getters: {
        getAll(state) {
            return state.serviceTypes;
        },
    },
    actions: {
        async fetchServiceTypes() {
            this.serviceTypes = [];
            try {
                const response = await (0, fetch_1.default)("/api/service-types/get", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                });
                if (response.error) {
                    throw new Error(i18n_1.default.trans("backend_service_type_error", "No service type found!", "backend_service_types"));
                }
                response.forEach((item) => {
                    //console.log(item);
                    this.serviceTypes.push(item);
                });
            }
            catch (error) {
                console.error(error);
                throw error;
            }
        },
    },
});
